import React from "react";
import Pagination from "@mui/material/Pagination";

const PaginationComponent = ({
  totalPages,
  currentPage,
  setCurrentPage,
  defaultActiveColor = "var(--primary-clr)",
}) => {
  const handleChange = (event, value) => {
    setCurrentPage(value);
  };
  return (
    <>
      <style>{`
        .MuiPagination-ul li .Mui-selected {
            background: ${defaultActiveColor} !important;
            color: var(--white-clr) !important;
            font-size:16px !important;
            min-width: 30px !important;
            height: 30px !important;
            font-family:"Poppins-semiBold" !important;
        }
        .MuiPagination-ul li button {
            color: var(--text-black-clr) !important;
            font-size:16px !important;
            font-family:"Poppins-semiBold" !important;
        }
    `}</style>
      <div>
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={handleChange}
        />
      </div>
    </>
  );
};

export default PaginationComponent;
